import classnames from "classnames";
import { AnimatePresence } from "framer-motion";
import React, { Children } from "react";
import { useTranslation } from "react-i18next";

import TrashIcon from "@krea/customer-features/images/svg/trash.svg";
import ExpandAnimation from "@krea/customer-features/shared-components/animations/Expand";
import { Error } from "@krea/customer-features/shared-components/fields/error";
import Fieldset from "@krea/customer-features/shared-components/fields/fieldset";
import { FileInput } from "@krea/customer-features/shared-components/fields/file/index";
import FileSection from "@krea/customer-features/shared-components/fields/file-section";
import FileSectionAction from "@krea/customer-features/shared-components/fields/file-section/FileSectionAction";
import FilesList from "@krea/customer-features/shared-components/fields/files-list";
import InputLink from "@krea/customer-features/shared-components/fields/input-link";
import { Text } from "@krea/customer-features/shared-components/text";

const LeasingOffer = ({
  files,
  url,
  onChangeLink,
  onBlurLink,
  offerIsEmpty,
  errorFiles,
  errorLink,
  onPostFiles,
  onDeleteFile,
  size,
  isFieldRequest,
}) => {
  const { t } = useTranslation();
  const textDelete = t("commons.delete");

  const postFiles = (files) => {
    onPostFiles && onPostFiles(files);
  };

  const deleteFile = (fileName, fileId, index) => {
    onDeleteFile && onDeleteFile({ fileName, fileId, index });
  };

  return (
    <div>
      <Text className="mb-2 font-weight-bold" size="md">
        {t("applicationForm.leasing.fields.offer.label")}
      </Text>

      <Fieldset
        className={classnames("p-5 border rounded", {
          "border-danger": offerIsEmpty,
        })}
      >
        <FileInput
          multiple
          id="OffersFileInput"
          name="leasing_object_offer_files"
          files={files}
          postFiles={(e) => postFiles(e)}
          error={errorFiles}
        />

        {files && files.length > 0 && (
          <FilesList label={t("iaq.uploadedFiles")} className="mt-n0">
            <AnimatePresence>
              {Children.toArray(
                files.map((file, index) => {
                  return (
                    <ExpandAnimation>
                      <FileSection
                        title={file?.name || file?.original_file_name}
                        actions={
                          <FileSectionAction
                            title={textDelete}
                            icon={TrashIcon}
                            onClick={() =>
                              deleteFile(
                                file?.name || file?.original_file_name,
                                file?.file_id,
                                index,
                              )
                            }
                          />
                        }
                      />
                    </ExpandAnimation>
                  );
                }),
              )}
            </AnimatePresence>
          </FilesList>
        )}

        <div>
          <Fieldset>
            <InputLink
              size={size}
              label={
                isFieldRequest
                  ? t(
                      "applicationForm.leasing.fields.offer.links.link.label.fieldRequest",
                    )
                  : t(
                      "applicationForm.leasing.fields.offer.links.link.label.appForm",
                    )
              }
              placeholder={t(
                "applicationForm.leasing.fields.offer.links.link.placeholder",
              )}
              id="leasing_object_offer_url"
              name="leasing_object_offer_url"
              value={url}
              autoFocus={false}
              onChange={(e) => onChangeLink(e)}
              onBlur={(e) => onBlurLink && onBlurLink(e)}
              error={errorLink}
            />
          </Fieldset>
        </div>
      </Fieldset>

      {offerIsEmpty && (
        <Error className="mt-1">
          {t("applicationForm.leasing.fields.offer.errors.empty")}
        </Error>
      )}
    </div>
  );
};

export default LeasingOffer;
